import React from 'react'
import TopBreadcrumb from 'components/TopBreadCrumb'
import RaceList from '../../Exam/RaceList/RaceList'

const Page = () => {
  const breadcrumbList = [{ name: '考核' }, { name: '竞赛结果' }]
  return (
    <div
      style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '0 24px 24px' }}
    >
      <TopBreadcrumb breadcrumbList={breadcrumbList} />
      <RaceList customStyle={{ padding: 0 }} />
    </div>
  )
}

export default Page
